import React, { useState } from 'react';
import { FadeIn, CountdownTimer, Button } from './Shared';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MEGAPACK CALMA TOTAL',
      subtitle: '6 Tomos + 4 Bonos',
      ideal: 'Ideal para: Padres y madres con hijos de 1 a 7 años que quieren manejar berrinches, poner límites y reconectar con sus hijos.',
      oldPrice: '$69.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48649260237017:1',
      buttonText: 'MEGAPACK CALMA TOTAL'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MEGAPACK CALMA TOTAL + MÉTODO RAÍCES',
      subtitle: '6 Tomos + 4 Bonos + Manual de Autoestima Infantil',
      ideal: 'Ideal para: Padres que ya quieren ir más allá de los berrinches y construir la autoestima, la resiliencia y la seguridad interior de su hijo.',
      oldPrice: '$89.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48649260368089:1',
      buttonText: 'MEGAPACK + MÉTODO RAÍCES',
      isPopular: true
    }
  };
  const currentPlan = plans[plan];
  return <section id="pricing" className="py-12 md:py-20 px-4 bg-navy-950 relative overflow-hidden" data-id="element-240">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.05),transparent_70%)] pointer-events-none" data-id="element-241"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-242">
        <FadeIn data-id="element-243">
          <div className="text-center mb-12" data-id="element-244">
            <h2 className="text-xs md:text-sm font-black tracking-[0.2em] text-red-500 uppercase mb-8 bg-red-500/10 inline-block px-4 py-2 rounded-full border border-red-500/20" data-id="element-245">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-246" />

            <div className="max-w-sm mx-auto mt-10 bg-navy-900/60 border border-white/10 rounded-2xl p-5 backdrop-blur-md shadow-2xl" data-id="element-247">
              <div className="flex justify-between items-center text-[10px] md:text-xs font-black mb-3 uppercase tracking-widest" data-id="element-248">
                <span className="text-gray-300 flex items-center gap-2" data-id="element-249">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-250"></span>
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-red-400" data-id="element-251">68% Reclamado</span>
              </div>
              <div className="h-2 bg-navy-950 rounded-full overflow-hidden border border-white/5 p-0.5" data-id="element-252">
                <div className="h-full bg-gradient-to-r from-premium-gold via-premium-gold-luminous to-red-500 w-[68%] rounded-full relative" data-id="element-253">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-254"></div>
                </div>
              </div>
              <p className="text-[11px] text-gray-400 mt-3 font-bold tracking-wide" data-id="element-255">
                Quedan pocos accesos disponibles a precio de lanzamiento
              </p>
            </div>

            <p className="mt-8 font-sans font-medium text-lg text-[#FFD700]" data-id="element-256">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
            <h3 className="text-4xl md:text-6xl font-black text-white mt-12 mb-10 uppercase tracking-tight leading-none font-[Montserrat,_sans-serif]" data-id="element-257">
              ELEGÍ TU <span className="text-[#FFD700]" data-id="element-258">MEGAPACK</span>
            </h3>
          </div>

          <div id="planes-container" className="space-y-6 mb-10 scroll-mt-24" data-id="element-259">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} id={`plan-${p.id}`} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-500 rounded-3xl p-6 md:p-10 border-2 flex items-center gap-4 md:gap-8 relative overflow-hidden scroll-mt-28 md:scroll-mt-32 ${isSelected ? 'bg-gradient-to-br from-navy-800 to-navy-900 border-premium-gold shadow-[0_0_50px_rgba(212,175,55,0.15)] transform scale-[1.02] z-10' : 'bg-navy-900/40 border-white/10 hover:border-white/20 hover:bg-navy-800/40'}`} data-id="element-260">
                  {isSelected && <div className="absolute top-0 left-0 w-1.5 h-full bg-gradient-to-b from-premium-gold-light via-premium-gold to-premium-gold-dark" data-id="element-261" />}

                  {/* Radio Indicator */}
                  <div className={`w-8 h-8 rounded-full border-2 shrink-0 flex items-center justify-center transition-all duration-500 ${isSelected ? 'border-premium-gold bg-premium-gold/10 scale-110' : 'border-white/20 bg-navy-950'}`} data-id="element-262">
                    {isSelected && <div className="w-4 h-4 rounded-full bg-premium-gold-luminous shadow-[0_0_15px_rgba(255,215,0,0.8)]" data-id="element-263" />}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-264">
                    <div className="flex items-center flex-wrap gap-3 mb-2" data-id="element-265">
                      <span className="text-2xl shrink-0 filter drop-shadow-md" data-id="element-266">
                        {p.icon}
                      </span>
                      <h4 className={`text-lg md:text-2xl font-black uppercase tracking-tight break-words leading-none ${isSelected ? 'text-premium-gold-luminous' : 'text-white'}`} data-id="element-267">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="text-[10px] md:text-xs bg-gradient-to-r from-premium-gold via-premium-gold-luminous to-premium-gold-dark text-navy-950 font-bold px-4 py-1 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] uppercase tracking-widest ml-1 font-sans" data-id="element-268">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className={`text-sm md:text-lg mb-2 font-sans font-medium break-words ${isSelected ? 'text-white' : 'text-gray-300'}`} data-id="element-269">
                      {p.subtitle}
                    </p>
                    <p className={`text-[11px] md:text-sm font-medium tracking-wide leading-relaxed break-words font-sans ${isSelected ? 'text-premium-gold-light/80' : 'text-gray-400'}`} data-id="element-270">
                      {p.ideal}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0 ml-auto" data-id="element-271">
                    <p className={`line-through text-xs md:text-base mb-1 font-bold opacity-60 ${isSelected ? 'text-white' : 'text-gray-400'}`} data-id="element-272">
                      {p.oldPrice}
                    </p>
                    <p className={`text-2xl md:text-5xl font-black transition-colors tracking-tighter ${isSelected ? 'text-premium-gold-luminous drop-shadow-[0_0_15px_rgba(255,215,0,0.3)]' : 'text-white'}`} data-id="element-273">
                      {p.price}{' '}
                      <span className={`text-xs md:text-lg font-black block md:inline opacity-80 ${isSelected ? 'text-premium-gold-luminous' : 'text-gray-400'}`} data-id="element-274">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-12" data-id="element-275">
            <Button href={currentPlan.url} className="w-full text-lg md:text-2xl py-6 md:py-8 shadow-[0_0_50px_rgba(212,175,55,0.4)]" data-id="element-276">
              🟠 → QUIERO EL {currentPlan.buttonText}
            </Button>
            <div className="flex flex-col items-center mt-6 text-gray-200 text-sm gap-2" data-id="element-277">
              <p className="flex items-center gap-2" data-id="element-278">
                <span className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" data-id="element-279" />
                Acceso inmediato por email • Pago seguro
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};